import { RawDraftContentState } from 'draft-js';
import { isNull } from 'lodash/fp';
import React, { useCallback } from 'react';

import { useAppDispatch } from '../../../../hooks/react-redux';
import { isEmpty, WYSIWYG } from '../../../shared/wysiwyg/WYSIWYG';
import { ReportEmailAttachment, retrieveRelevantReportTemplates, SendReportEmailScheduler, setScheduledReportEmailContent } from '../store';
import styles from '../Workflow.module.scss';
import { EmailHeaderElements } from './EmailHeaderElements';
import { useFetchStarted } from '../../../../hooks/useFetchStarted';
import { ReportAttachment } from './ReportAttachment';

interface ScheduleReportEmailContentProps {
    event: SendReportEmailScheduler;
    testId: string;
    isEditing: boolean;
}

export const ScheduleReportEmailContent: React.FC<ScheduleReportEmailContentProps> = ({ event, testId, isEditing }) => {
    const dispatch = useAppDispatch();
    useFetchStarted([retrieveRelevantReportTemplates()]);

    const { content } = event;
    const { userIds, subject, wysiwygTemplate, attachment } = content;

    const setEmailUserIds = useCallback((value: number[] | null) => dispatch(setScheduledReportEmailContent('userIds', value)), [dispatch]);
    const setEmailSubject = useCallback((value: string) => dispatch(setScheduledReportEmailContent('subject', value)), [dispatch]);

    const setEmailBody = useCallback((rawValue: RawDraftContentState) => {
        if (isEmpty(rawValue)) {
            if (!isNull(wysiwygTemplate)) {
                dispatch(setScheduledReportEmailContent('wysiwygTemplate', null));
            }
        } else {
            dispatch(setScheduledReportEmailContent('wysiwygTemplate', rawValue));
        }
    }, [dispatch, wysiwygTemplate]);

    const updateReportAttachment = useCallback((attachment: ReportEmailAttachment | null) => dispatch(setScheduledReportEmailContent('attachment', attachment)), [dispatch]);
    return (
        <div className={styles.emailContentTabWrapper} data-testid={`${testId}-wrapper`}>
            <EmailHeaderElements userIds={userIds} subject={subject} updateSubject={setEmailSubject} updateUserIds={setEmailUserIds} testId={testId} isEditing={isEditing} />
            <ReportAttachment attachment={attachment} testId={testId} isEditing={isEditing} updateReportAttachment={updateReportAttachment} />
            <div className={styles.reportEmailBodyWrapper} data-testid={`${testId}-body-wrapper`}>
                <WYSIWYG
                    content={wysiwygTemplate}
                    updateContent={val => setEmailBody(val)}
                    height='100%'
                    maxHeight='100%'
                    minHeight='100%'
                    disabled={!isEditing}
                    toolbarHidden={!isEditing}
                />
            </div>
        </div>
    );
};

